import { FC } from "react";

const Recipes: FC = () => {
  return <div>Recipes</div>;
};

export default Recipes;
